import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import classnames from 'classnames';
import React, { useContext } from 'react';
import { useDeepEqualMemo } from '@wix/da-hooks/pkg/useDeepEqualMemo';
import { ThemeOptions } from './constants';
export function getGlobalClassnamesForContext({ isMobile , theme , isSisu , flags ={} , themeSkin  }) {
    return classnames(isMobile && 'mobile', !isSisu && `theme-${(theme || ThemeOptions.DARK).toString()}`, isSisu && 'sisu', themeSkin && themeSkin, flags['status_font_sizes'] && 'status_font_sizes');
}
export function getForcedGlobalClassnamesForContext({ theme  }) {
    return `theme-${theme} forced-theme-${theme}`;
}
export function getComponentName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// Helper to create a context provider component that instead of replacing
// parent values, it merges them with the provided ones
export function createMergingContextProvider(context, displayName = `${context.displayName || 'Context'}Provider`) {
    const MergingContextProvider = ({ children , value  })=>{
        const parentContext = useContext(context);
        const merged = useDeepEqualMemo(_object_spread({}, parentContext, value));
        return /*#__PURE__*/ React.createElement(context.Provider, {
            value: merged
        }, children);
    };
    MergingContextProvider.displayName = displayName;
    return MergingContextProvider;
}
